import { render, staticRenderFns } from "./StepsPage.vue?vue&type=template&id=3c82963f&scoped=true"
import script from "./StepsPage.vue?vue&type=script&lang=js"
export * from "./StepsPage.vue?vue&type=script&lang=js"
import style0 from "./StepsPage.vue?vue&type=style&index=0&id=3c82963f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c82963f",
  null
  
)

export default component.exports